import { useState } from "react";
import { Modal, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const TutorialPopup = () => {
  const [ismodalVisible, setIsModalVisible] = useState(false);
  const [buttonHide, setButtonHide] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
    setButtonHide(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setButtonHide(false);
  };
  const hideTutorialButton = () => {
    setButtonHide(true);
  };
  return (
    <div className="tutorial-popup">
      <Button
        type="primary"
        className="tutorial-button"
        onClick={() => {
          showModal();
          hideTutorialButton();
        }}
        style={{ display: buttonHide ? "none" : null }}
      >
        tutorial &nbsp;<span className="tutorial-button-arab">تعليمات</span>
        &nbsp;
        <img
          src={"/icons/tutorial_white_icon.svg"}
          style={{ width: "22px" }}
          onMouseEnter={(e) =>
            (e.target.src = "/icons/tutorial_black_icon.svg")
          }
          onMouseLeave={(e) =>
            (e.target.src = "/icons/tutorial_white_icon.svg")
          }
          alt="Tutorial Icon"
        />
      </Button>
      <Modal
        width="50%"
        wrapClassName={"tutorial-popup-modal"}
        title={
          <div>
            <span className="tutorial-popup-modal-engtitle">tutorial </span>
            <span className="tutorial-popup-modal-arabtitle"> درس خصوصي</span>
          </div>
        }
        centered
        visible={ismodalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={<CloseCircleOutlined />}
      >
        <video style={{ width: "100%" }} controls>
          <source src="/vid/bilingualwebsite-tutorial.mp4" type="video/mp4" />
        </video>
      </Modal>
    </div>
  );
};

export default TutorialPopup;
